import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ServerAddress } from '../MyAppCommonConfig';
import { CAnswerStatus } from '../models/onlineAnswer.models/answerStatus.model';

@Injectable()
export class OnlineAnswerService {
    constructor(private http: HttpClient) {

    }

    GetStatusAnswer(AcceptationNumber: string, TelephonOrMobile: string) {
        return this.http.get<CAnswerStatus>(API_ServerAddress + 'api/NovinLaboratory/NovinAnswering/AnswerStatus?AcceptationNumber=' + AcceptationNumber + '&TelephonOrMobile=' + TelephonOrMobile);
    }

    GetListShamsiYears() {
        // now returns an Observable of string[]
        return this.http.get<number[]>(API_ServerAddress + 'api/NovinLaboratory/NovinAnswering/ListShamsiYears');
    }

    GetDownloadAnswerUrl(acceptionCode: string, phone: string): string {
        return API_ServerAddress + '/api/NovinLaboratory/NovinAnswering/DownloadAnswerFile?AcceptationNumber=' + acceptionCode + '&TelephonOrMobile=' + phone;
    }

    GetAcceptionPaymentUrl(fCode: string, fReturnUrlSuccess: string, fReturnUrlFailure: string): string {
        return API_ServerAddress + '/api/Payment/StartBuy?fId=' + fCode + '&TypeFactorFlag=0&fReturnUrlSuccess=' + fReturnUrlSuccess + '&fReturnUrlFailure=' + fReturnUrlFailure;
    }

}